import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { EnrollQuery } from 'queries';
import {
  getApplicationBaseOrder,
  getApplicationBaseType,
  getApplicationTypeLabel,
  getGeneralEnrollCount,
} from 'types';
import useDetail from './useDetail';

function useStatistics() {
  const { id } = useParams();
  const { event } = useDetail();
  const { data } = EnrollQuery.useGetSummaryByEvent(id || '');

  const isLottery = event?.recruitmentType === 'LOTTERY';

  const countsByBase = useMemo(() => {
    const NO_TYPE = '';
    const merged: Record<string, number> = {};
    const order: string[] = [];

    (data?.applicationTypeCounts || []).forEach(
      ({ applicationType, count }) => {
        const key = applicationType
          ? getApplicationBaseType(applicationType)
          : NO_TYPE;

        if (!(key in merged)) order.push(key);
        merged[key] = (merged[key] ?? 0) + Number(count || 0);
      },
    );

    return order
      .sort((a, b) => getApplicationBaseOrder(a) - getApplicationBaseOrder(b))
      .map((base) => ({
        label: base ? getApplicationTypeLabel(base) : '일반',
        count: merged[base],
        isTyped: base !== NO_TYPE,
      }));
  }, [data]);

  const detailItems = useMemo(() => {
    if (!isLottery) {
      return countsByBase.map(({ label, count }) => ({ label, count }));
    }

    return [
      { label: '참여 확정', count: Number(data?.selectedGeneralCount || 0) },
      { label: '미선정', count: Number(data?.notSelectedCount || 0) },
      ...countsByBase
        .filter(({ isTyped }) => isTyped)
        .map(({ label, count }) => ({ label, count })),
    ];
  }, [data, isLottery, countsByBase]);

  return {
    enrollCount: getGeneralEnrollCount(data),
    cancelCount: Number(data?.cancelCount || 0),
    feedbackCount: Number(data?.feedbackCount || 0),
    lateOrAbsentCount:
      Number(data?.lateCount || 0) + Number(data?.absentCount || 0),
    detailItems,
  };
}

export default useStatistics;
